import { gql } from '@apollo/client'

export const GET_LOGGED_IN_USER_ULTRA = gql`
  query UltraGetLoggedInUser {
    loggedInUser {
      uuid
      id
      email
      name
      firstName
      lastName
      username
      isActive
      isStaff
      isSuperuser
      dateRemoved
      companyName
      roles
    }
  }
`

export type UltraGetLoggedInUserQuery = {
  loggedInUser: {
    __typename: 'UserType'
    uuid: string
    id: string
    email: string
    name: string
    firstName: string
    lastName: string
    username: string
    isActive: boolean
    isStaff: boolean
    isSuperuser: boolean
    dateRemoved: any | null
    companyName: string | null
    roles: Array<string>
  } | null
}
